export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';


export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'th';
export const localeOptions = [{ id: 'th', name: 'Thai', direction: 'ltr' }];

export const basename = '/survey';
export const adminRoot = '/admin';
export const buyUrl = '';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const currentUser = { uid: "gpfsurvey", "id": 1, title: "Admin", img: "/assets/img/profiles/l-1.jpg", date: "", role: 0 };

const urlRoute_temp = window.location.href;
let routeType_temp = 0;
let api_endpoint_temp = '';
let apidash_endpoint_temp = '';
let apiview_endpoint_temp = '';
let ansview_uri_temp = '';
let socketio_temp_url = '';
let public_key_temp = '';
let loginurl_temp = '';

let surveyAnswerURL = ['https://testres.gpf.or.th', 'https://res.gpf.or.th'];
var checkAnswerURL = new RegExp(surveyAnswerURL.join('|')).test(urlRoute_temp);

if (checkAnswerURL) {
  routeType_temp = 1;
  api_endpoint_temp = '';
  apidash_endpoint_temp =''
  // ## Production ##
  apiview_endpoint_temp = 'https://res.gpf.or.th/GPFSurveyAPI/apiRespondent';

  // ## Dev / Test ##
  // apiview_endpoint_temp = 'https://testres.gpf.or.th/GPFSurveyAPI/apiRespondent';

  ansview_uri_temp = '';

  /*public_key_temp = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArqO3C35j15oKoTE7EuiS
sr/zHGOiSD5JstU8QEWWjdtsmDQBtdknQjbuEw5JxisXBT/COCwKG4jt65QuPxGr
q8e+DLTCs45Sc1vvzET35S4St4VB+SeVg6ykI/v89wQ4zf18u528GnHYqf6UxbPl
KZDLirkMl8lYRLa/19WnFq2mJV2qbRbnZgyizPkEtk1QDY5/SxE+N8tbceWvbKt6
KOPNnmUygcUeT3rbD9uljRa6X7EuF5Ukr+GcaUkC7KAs3PJFsFRQxZoXWxYO+bKF
ckKLwPDVJXjvW67H4i7XlgWd80XLduet2qFdZVIM/JvsXNkHGJCaZkeUpkiBlLwb
lwIDAQAB
-----END PUBLIC KEY-----`;*/

} else {
  routeType_temp = 2;
  // ## Production ##
  ansview_uri_temp = 'https://res.gpf.or.th';
  api_endpoint_temp = 'https://onl-pngx-000.gpf.or.th/GPFSurveyAPI/api';
  apidash_endpoint_temp = 'https://onl-pngx-000.gpf.or.th/GPFSurveyAPI/apidashboard';
  apiview_endpoint_temp = 'https://onl-pngx-000.gpf.or.th/GPFSurveyAPI/apiRespondent';
  loginurl_temp = 'https://onl-pngx-000.gpf.or.th/GPFSurveyAPI/apiauth';

  // ## Dev / Test ##
  // ansview_uri_temp = 'https://testres.gpf.or.th';
  // api_endpoint_temp = 'https://onl-tngx-000.gpf.or.th/GPFSurveyAPI/api';
  // apidash_endpoint_temp = 'https://onl-tngx-000.gpf.or.th/GPFSurveyAPI/apidashboard';
  // apiview_endpoint_temp = 'https://onl-tngx-000.gpf.or.th/GPFSurveyAPI/apiRespondent';
  // // apiview_endpoint_temp = 'https://testres.gpf.or.th/GPFSurveyAPI/apiRespondent';
  // loginurl_temp = 'https://onl-tngx-000.gpf.or.th/GPFSurveyAPI/apiauth';

  // ## From Local ##
  // ansview_uri_temp = 'http://localhost:3000';
  // api_endpoint_temp = 'https://testres_local.gpf.or.th:9000/api';
  // apidash_endpoint_temp ='https://testres_local.gpf.or.th:9000/apidashboard'
  // apiview_endpoint_temp = 'https://testres_local.gpf.or.th:9000/apiRespondent';
  // loginurl_temp = 'https://testres_local.gpf.or.th:9000/apiauth';

  if (socketio_temp_url == '') {
    socketio_temp_url = api_endpoint_temp;
  }

  /*public_key_temp = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArqO3C35j15oKoTE7EuiS
sr/zHGOiSD5JstU8QEWWjdtsmDQBtdknQjbuEw5JxisXBT/COCwKG4jt65QuPxGr
q8e+DLTCs45Sc1vvzET35S4St4VB+SeVg6ykI/v89wQ4zf18u528GnHYqf6UxbPl
KZDLirkMl8lYRLa/19WnFq2mJV2qbRbnZgyizPkEtk1QDY5/SxE+N8tbceWvbKt6
KOPNnmUygcUeT3rbD9uljRa6X7EuF5Ukr+GcaUkC7KAs3PJFsFRQxZoXWxYO+bKF
ckKLwPDVJXjvW67H4i7XlgWd80XLduet2qFdZVIM/JvsXNkHGJCaZkeUpkiBlLwb
lwIDAQAB
-----END PUBLIC KEY-----`;*/
}

export const routeType = routeType_temp;
export const api_endpoint = api_endpoint_temp;
export const apiview_endpoint = apiview_endpoint_temp;
export const apidash_endpoint = apidash_endpoint_temp;
export const ansview_uri = ansview_uri_temp;
export const socketio_url = socketio_temp_url;
export const public_key = public_key_temp;
export const loginurl = loginurl_temp

export const session_timeout = 60; // Config session timeout time in minutes (120 minutes as 2 hrs)

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.blueolympic';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = ['blueolympic'];